var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertIconNew = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5003 2.16675C6.1741 2.16675 2.66699 5.67385 2.66699 10.0001C2.66699 14.3263 6.1741 17.8334 10.5003 17.8334C14.8266 17.8334 18.3337 14.3263 18.3337 10.0001C18.3337 5.67385 14.8266 2.16675 10.5003 2.16675ZM1.66699 10.0001C1.66699 5.12157 5.62181 1.16675 10.5003 1.16675C15.3788 1.16675 19.3337 5.12157 19.3337 10.0001C19.3337 14.8786 15.3788 18.8334 10.5003 18.8334C5.62181 18.8334 1.66699 14.8786 1.66699 10.0001ZM10.5003 6.16675C10.7765 6.16675 11.0003 6.39061 11.0003 6.66675V10.8334C11.0003 11.1096 10.7765 11.3334 10.5003 11.3334C10.2242 11.3334 10.0003 11.1096 10.0003 10.8334V6.66675C10.0003 6.39061 10.2242 6.16675 10.5003 6.16675Z",
    fill: "#23252F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 13.3334C11.3337 13.7937 10.9606 14.1667 10.5003 14.1667C10.0401 14.1667 9.66699 13.7937 9.66699 13.3334C9.66699 12.8732 10.0401 12.5001 10.5003 12.5001C10.9606 12.5001 11.3337 12.8732 11.3337 13.3334Z",
    fill: "#23252F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertIconNew);
export default ForwardRef;